export default __webpack_public_path__ + "static/media/10.71c422a6.jpg";